import { updateSharingLinkUrl } from '../actions/internalActions';
import { onFluidLinkCreated } from '../actions/subscribableActions';
import getSharingLinkInfo from '../selectors/getSharingLinkInfo';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { mutator } from 'satcheljs';

mutator(updateSharingLinkUrl, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLinkInfo(actionMessage.linkId);

    sharingLink.url = actionMessage.newLinkUrl;
});

mutator(onFluidLinkCreated, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLinkInfo(actionMessage.linkId);
    sharingLink.url = actionMessage.url;
});
